import React from 'react'
import { HiOutlineX } from 'react-icons/hi';
import { useNavigate } from 'react-router-dom';

const CloseButton = () => {
    const navigate = useNavigate();

  return (
    <button onClick={() => navigate(-1)} className='text-skin-base bg-black/5 dark:bg-white/5 p-3 rounded-custom backdrop-blur-md'><HiOutlineX className="w-8 h-8" /></button>
  )
}

export default CloseButton